const setPhoneNumbersLookupTable = function (state, idKey: string) {
  const lookupTable = {}
  const records = state.phoneNumbers
  const totalRecords = records?.length

  // Iterate over the array and add each item to the lookup table.
  for (let index = 0; index < totalRecords; ++index) {
    const item = records[index]
    const id = item[idKey]
    lookupTable[id] = index
  }

  state.phoneNumbersSIDIndexLookup = {}
  state.phoneNumbersSIDIndexLookup = lookupTable
}

export default setPhoneNumbersLookupTable
